// src/pages/QuizPage.js
import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuiz } from '../context/QuizContext';
import Quiz from '../components/Quiz';

function QuizPage() {
  const { state: urlState, category } = useParams();
  const { t } = useTranslation();
  const { state, dispatch } = useQuiz();

  React.useEffect(() => {
    if (urlState) {
      dispatch({ type: 'SET_STATE', state: urlState });
    }
    if (category) {
      dispatch({ type: 'SET_CATEGORY', category });
    }
  }, [urlState, category, dispatch]);

  return (
    <div className="container py-4">
      <h1 className="mb-4">{t('quiz.title')}</h1>
      <Quiz />
    </div>
  );
}

export default QuizPage;
